import { RouteComponentProps } from '@reach/router';
import { PureComponent } from 'react';
import { connect, MapStateToProps } from 'react-redux';
import {
  AvatarAndNameWrapper,
  HeaderContent,
  // LinksWrapper,
  Name,
  // UserAvatar,
  // Location,
  WorkingContext,
  SiteHeader,
  SiteHeaderHome,
  SiteHeaderTitle,
  Header,
  // Description,
  // Distance,
  CarouselContainer,
  CarouselImage,
  UserBadgeContainer,
  CarouselVideo,
  UserAvatar,
  CaresoulImageSliderContainer,
  SliderCard,
  SliderCardImage,
  HeaderContainer,
  WebNameContainer,
  // HCarouselContainer,
} from './styles';
import Icon from '../../../../components/Icon/Icon';
import { getDomainAndPort } from '../../../../api/Utils';
// import { darkGreen } from '../../../../utils/style/colors';
import { distance } from '../../../../utils/happyFunctions';
import Modal from '../../../../components/Modal';
import Search from '../../../../components/Search/Search';
import { Container } from '../../../../custom/styles';
import {
  IProvider,
  IProviderItemView,
  ITagView,
} from 'store/providers/providerTypes';
import { IThisUser } from '../../../../store/thisUser/thisUserSlice';
import BadgeProfileDropdown from '../../../../components/Dropdown/BadgeProfileDropdown';
import {
  pictureFormat,
  videoFormat,
} from '../../../../utils/check-file-type/listOfFilesFormat';
import i18n from 'i18next';
import { ProfileDropDownHeader } from '../../../../components/Sidebar/styles';
import { appDispatch, RootState } from 'store/store';
// import { getProviderDocuments, getProviderDocumentsByExtraIds } from 'api/ManApi';
import { requireDocumentInFolder } from 'store/providers/providerSlice';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider, { Settings } from 'react-slick';
import { StringOrNull } from 'store/entity/types';
import { CONF_BANNER } from '../MobileProfileContainer';
import { HeaderLogo } from '../HorizentalFolderView/styles';
import webda from '../../../../assets/images/webda.svg';

interface IDispatchToProps {}

interface IComponentStates {
  distance?: number;
  isModalOpen: boolean;
}
interface IOwnProps {
  provider: IProvider;
  onChangeChatbotStatus: (status: boolean) => void;
  onChangeContributionStatus: (status: boolean) => void;
  thisUser: IThisUser | null;
  companyId: number | null;
  showBanner: boolean;
  rootFolderId: number;
  childOfRootFolder: IProviderItemView;
}

interface IStateToProps {
  bannerItems: IProviderItemView[] | null;
  providerName: StringOrNull | undefined;
  bannerFolder: 0 | IProviderItemView | undefined;
}

type IComponentProps = IDispatchToProps & IStateToProps & IOwnProps;

export function getProviderAddress(provider: IProvider): string {
  let ret =
    (provider.address.city ? provider.address.city : ' ') +
    ' ' +
    (provider.address.mainStreat
      ? ' خیابان ' + provider.address.mainStreat + ' '
      : '') +
    (provider.address.secondaryStreet
      ? ' خیابان ' + provider.address.secondaryStreet + ' '
      : '') +
    (provider.address.alley ? ' کوچه ' + provider.address.alley + ' ' : '') +
    (provider.address.deadEnd
      ? ' بن‌بست ' + provider.address.deadEnd + ' '
      : '') +
    (provider.address.number ? ' پلاک ' + provider.address.number + ' ' : '') +
    (provider.address.buildingName
      ? ' ساختمان ' + provider.address.buildingName + ' '
      : '') +
    (provider.address.floor ? ' طبقه ' + provider.address.floor + ' ' : '') +
    (provider.address.unit ? ' واحد ' + provider.address.unit + ' ' : '');
  ret = ret.trim();
  if (ret) return ret;
  return provider.address.text;
}

type TViewport = 'conf_medium_viewport' | 'conf_small_viewport' | 'auto';

const MEDIUM_VIEWPORT = 'conf_medium_viewport';
const SMALL_VIEWPORT = 'conf_small_viewport';

const IOS_BANNER = 'conf_IOS_Banner';

const imageSliderSettings: Settings = {
  dots: true,
  arrows: true,
  infinite: false,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1,
};

class ProfileHead extends PureComponent<IComponentProps, IComponentStates> {
  state: IComponentStates = {
    isModalOpen: false,
  };

  componentDidMount(): void {
    this.calculateDistance();

    if (this.props.bannerFolder === undefined && this.props.childOfRootFolder) {
      appDispatch(
        requireDocumentInFolder({
          providerId: this.props.provider.id,
          folderId: this.props.childOfRootFolder.dadId,
        })
      );
    }
  }

  async componentDidUpdate(
    prevProps: Readonly<IComponentProps>
  ): Promise<void> {
    if (
      (this.props.bannerFolder as IProviderItemView)?.id !==
        (prevProps.bannerFolder as IProviderItemView)?.id &&
      (this.props.bannerFolder as IProviderItemView)?.id &&
      this.props.provider?.id &&
      this.props.bannerFolder
    ) {
      appDispatch(
        requireDocumentInFolder({
          providerId: this.props.provider.id,
          folderId: this.props.bannerFolder.id,
        })
      );
    }
  }

  calculateDistance = () => {
    const { provider } = this.props;
    if (provider.address.latitude && this.props.provider.address.longitude)
      window.navigator.geolocation.getCurrentPosition((pos) => {
        if (pos.coords.accuracy < 1000) {
          const d = distance(
            pos.coords.longitude,
            pos.coords.latitude,
            provider.address.longitude,
            provider.address.latitude
          );
          this.setState({ distance: d * 1000 });
        }
      });
  };

  getBannerHeightWidth = (conf_name: TViewport) => {
    const viewport = { height: 'auto', width: 'auto' };
    if (conf_name === MEDIUM_VIEWPORT) return { height: '100%', width: '50vw' };
    else if (conf_name === SMALL_VIEWPORT)
      return { height: '100%', width: '30vw' };
    else return viewport;
  };

  getViewportViaTags = (tags: ITagView[]) => {
    const tagsText = tags?.map((tag) => tag.text);

    if (tagsText.includes('conf_full_viewport')) {
      return this.getBannerHeightWidth(MEDIUM_VIEWPORT);
    } else if (tagsText.includes('conf_small_viewport')) {
      return this.getBannerHeightWidth(SMALL_VIEWPORT);
    } else {
      return this.getBannerHeightWidth('auto');
    }
  };

  isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  render() {
    const { provider, thisUser, companyId } = this.props;

    const videoIOSBanner =
      this.props.bannerItems &&
      this.props.bannerItems.find(
        (item) =>
          videoFormat.includes(item?.document?.properties?.format) &&
          item?.tags.find((tag) => tag.text === IOS_BANNER)
      );

    const videoBanner =
      this.props.bannerItems &&
      this.props.bannerItems.find(
        (item) =>
          videoFormat.includes(item?.document?.properties?.format) &&
          !item?.tags.find((tag) => tag.text === IOS_BANNER)
      );

    const imagesBanner =
      this.props.bannerItems &&
      this.props.bannerItems.filter((item) =>
        pictureFormat.includes(item?.document?.properties.format)
      );

    const viewport: { height: string; width: string } = videoBanner
      ? this.getViewportViaTags(videoBanner.tags)
      : imagesBanner?.length === 1
        ? this.getViewportViaTags(imagesBanner[0]?.tags)
        : this.getBannerHeightWidth('auto');

    const profilePictureDoc = provider.documents.find(
      (it) => it.document?.documentType === 'profile_picture'
    );

    const allowSearch = getDomainAndPort().domainFeatures?.allowProfileSearch;

    const providerLogo = provider.documents.find(
      (it) => it.document?.documentType === 'profile_picture'
    );

    return (
      <Header>
        <Modal
          width="100%"
          title={''}
          onClose={() => this.setState({ isModalOpen: false })}
          isActive={this.state.isModalOpen}
          simpleModal
          mainStyle={{ backgroundColor: 'transparent', boxShadow: 'none' }}
        >
          <Container>
            <Search
              modalType
              callbackFunction={() => this.setState({ isModalOpen: false })}
            />
          </Container>
        </Modal>
        <HeaderContent>
          <SiteHeader>
            <SiteHeaderTitle to={'/'}></SiteHeaderTitle>
            {allowSearch && (
              <SiteHeaderHome
                onClick={() => this.setState({ isModalOpen: true })}
                style={{ left: '20px', right: 'auto' }}
              >
                <Icon type="search" style={{ fontSize: '21px' }} />
              </SiteHeaderHome>
            )}
          </SiteHeader>
          <AvatarAndNameWrapper>
            {profilePictureDoc && (
              <UserAvatar src={profilePictureDoc.document.url} alt="avatar" />
            )}
            <HeaderContainer>
              <WebNameContainer>
                <HeaderLogo src={providerLogo?.thumbnailUrl ?? webda} />
                <Name white={true}>{this.props.providerName}</Name>
              </WebNameContainer>
              {thisUser?.isLoggedIn ? (
                <UserBadgeContainer>
                  <BadgeProfileDropdown
                    user={thisUser}
                    direction={'right'}
                    companyId={companyId as number}
                    isHidden={false}
                    isWebda={true}
                    isThemeEnabled={
                      !getDomainAndPort()?.domainFeatures?.forceTheme
                    }
                  />
                </UserBadgeContainer>
              ) : getDomainAndPort().domainFeatures?.enableLoginInPublicView ? (
                <UserBadgeContainer>
                  <ProfileDropDownHeader>
                    <a
                      href={`/login?redirect=${encodeURIComponent(window.location.href)}`}
                    >
                      {i18n.t('login') as string}
                    </a>
                  </ProfileDropDownHeader>
                </UserBadgeContainer>
              ) : null}
            </HeaderContainer>
            {this.props.bannerItems?.length ? (
              <CarouselContainer
                isImageSlider={(imagesBanner?.length ?? 0) > 1}
                isVideo={
                  (!imagesBanner?.length && (videoBanner || videoIOSBanner)) ||
                  (imagesBanner?.length ?? 0) > 0
                }
              >
                {imagesBanner?.length ? (
                  imagesBanner.length > 1 ? (
                    <CaresoulImageSliderContainer className="slider-container">
                      <Slider {...imageSliderSettings}>
                        {imagesBanner.map((imageItem, indx: number) => (
                          <div key={indx}>
                            <SliderCard className="glass-card" padding={0}>
                              <SliderCardImage
                                src={imageItem?.document?.url}
                                hasLink={!!imageItem?.moreInfoUrl}
                                onClick={() => {
                                  if (imageItem?.moreInfoUrl)
                                    window.open(imageItem.moreInfoUrl);
                                }}
                              />
                            </SliderCard>
                          </div>
                        ))}
                      </Slider>
                    </CaresoulImageSliderContainer>
                  ) : (
                    <CarouselImage
                      src={imagesBanner[0]?.document?.url}
                      alt="avatar"
                      viewport={viewport}
                    />
                  )
                ) : videoBanner || videoIOSBanner ? (
                  <CarouselVideo
                    autoPlay
                    muted
                    playsInline
                    controls={false}
                    loop
                    speed
                    src={
                      this.isSafari()
                        ? videoIOSBanner?.document.url
                        : videoBanner?.document.url
                    }
                    alt="avatar"
                    viewport={viewport}
                  />
                ) : null}
              </CarouselContainer>
            ) : (
              <></>
            )}
            {provider.publicProperties?.workingContext && (
              <WorkingContext>
                {provider.publicProperties?.workingContext}
              </WorkingContext>
            )}
          </AvatarAndNameWrapper>
          {/* {address && (
            <Location>
              <Icon
                type="map-pin"
                color={darkGreen}
                style={{ marginLeft: '5px' }}
              />
              <span>{address}</span>
              {distance && <Distance>{formatKM(distance)}</Distance>}
            </Location>
          )} */}
          {/* {provider.description && (
            <Description>{provider.description}</Description>
          )} */}
        </HeaderContent>
        {/* {hasAnyInfo && (
          <LinksWrapper>
            <a
              href={
                provider.address.latitude
                  ? `https://www.google.com/maps/search/?api=1&query=${provider.address.latitude},${provider.address.longitude}`
                  : undefined
              }
              target="blank"
            >
              <Icon
                type="map-pin"
                disabled={!provider.address.latitude}
                border
                color={darkGreen}
              />
            </a>
            <a href={provider.publicProperties?.website} target="blank">
              <Icon
                type="globe"
                disabled={!provider.publicProperties?.website}
                border
                color={darkGreen}
                title={provider.publicProperties?.website}
              />
            </a>
            {isMobileDevice ? (
              <a href={phone ? `tel:${phone}` : undefined}>
                <Icon border type="phone" color={darkGreen} disabled={!phone} />
              </a>
            ) : (
              <Icon
                type="phone"
                border
                titleClick
                title={phone}
                color={darkGreen}
                disabled={!phone}
              />
            )}
          </LinksWrapper>
        )} */}
      </Header>
    );
  }
}

const mapStateToProps: MapStateToProps<
  IStateToProps,
  IOwnProps & RouteComponentProps,
  RootState
> = (state, props) => {
  const bannerFolder =
    props.provider?.id &&
    Object.values(state.providers.items[props.provider.id]?.items || {})
      ?.filter((item) => item.data.dadId === props.childOfRootFolder.id)
      ?.map((el) => el.data)
      ?.find(
        (el) =>
          el.type === 'folder' &&
          el.tags.find((tag) => !tag?.deleted && tag.text === CONF_BANNER)
      );

  const bannerItems = Object.values(
    state.providers.items[Number(props.provider.id)].items
  )
    ?.map((item) => item.data)
    ?.filter((item) => item.dadId === (bannerFolder as IProviderItemView)?.id)
    ?.sort((a, b) => a.order - b.order);

  const providerName =
    props.rootFolderId !== props.provider.rootDocument.id
      ? (Object.values(state.providers.items[Number(props.provider.id)].items)
          ?.map((item) => item.data)
          ?.find((item) => item.id === props.rootFolderId)?.name ??
        props.provider.name)
      : props.provider.name;

  return { bannerItems, providerName, bannerFolder };
};

export default connect(mapStateToProps, null)(ProfileHead);
